import {
  api_request, auth_request
} from '@/utils/api';
import {
  // isDEV, LocationOrigin, dict2params,
  PaperScope, PaperProduct, xTokenKey,
} from "@/utils/request";

// 账户相关接口
// 8、用户名密码，登录账户（允许使用tel、account登录）
// http://dms.gene.ac/dev/api/info/?api_no=9fb5b52e311211e68a6b00163e002d04
export const post_auth_token_password = (rq, func)=>{
  auth_request({
    type: 'post',
    url: '/token/password/',
    data: {...rq, scope: PaperScope},
    crud_name: '获得动态口令 使用账户名密码',
    success: func
  });
};

// 1、登录/注册账户，发送验证码
// http://dms.gene.ac/dev/api/info/?api_no=fe325350d7474667bd7721c1f83e892d
export const post_auth_code_login = (rq, func)=>{
  auth_request({
    type: 'post',
    url: '/code/login/',
    data: {...rq, product: PaperProduct},
    crud_name: '登录/注册账户，发送验证码',
    success: func
  });
};


//     2、使用验证码，注册key=register
// http://dms.gene.ac/dev/api/info/?api_no=9ffb1ef8d93611e6a85a00163e1c20b1
export const post_auth_register_tel = (rq, func)=>{
  auth_request({
    type: 'post',
    url: '/register/tel/',
    data: {...rq, scope: PaperScope},
    crud_name: '注册用户 使用手机号和验证码',
    success: func
  });
};

//
//     3、使用验证码，登录账户
// http://dms.gene.ac/dev/api/info/?api_no=095e6264292f11e6b38300163e002d04
export const post_auth_token_tel = (rq, func)=>{
  auth_request({
    type: 'post',
    url: '/token/tel/',
    data: {...rq, scope: PaperScope},
    crud_name: '获得动态口令 通过绑定的手机号',
    success: func
  });
};
// 18、用户重置密码 登录后如果没设置密码
// http://dms.gene.ac/dev/api/info/?api_no=c23a14855f414d32b88ba1be91fb7aa1
// new_password	string	20	准备更改成的密码
// access_token	string		系统生成的动态口令
export const put_auth_password_reset_token = (rq, func)=>{
  auth_request({
    type: 'put',
    url: '/password/reset/token/',
    data: rq,
    crud_name: '用户重置密码',
    success: func
  });
};
//     4、重置密码，发送验证码
// http://dms.gene.ac/dev/api/info/?api_no=2a107fd0e1a711e59c2300163e002d04
export const post_auth_code_password = (rq, func)=>{
  auth_request({
    type: 'post',
    url: '/code/password/',
    data: {...rq, product: PaperProduct},
    crud_name: '使用绑定手机号重置密码，发送验证码',
    success: func
  });
};
//     5、使用验证码，重置密码
// http://dms.gene.ac/dev/api/info/?api_no=42741732e1aa11e5bc3800163e002d04
export const put_auth_password_reset = (rq, func)=>{
  auth_request({
    type: 'PUT',
    url: '/password/reset/',
    data: {...rq, scope: PaperScope},
    crud_name: '使用验证码，重置密码',
    success: func
  });
};
//     6、解绑手机号，发送验证码
// http://dms.gene.ac/dev/api/info/?api_no=29aa4b66e40411e5a85200163e002d04
export const post_auth_code_unbind = (rq, func)=>{
  auth_request({
    type: 'post',
    url: '/code/unbind/',
    data: {...rq, product: PaperProduct},
    crud_name: '解除手机号绑定， 发送验证码',
    success: func
  });
};
//
//     7、使用验证码，解绑手机号
// http://dms.gene.ac/dev/api/info/?api_no=957d4a26e40611e59d6400163e002d04
export const delete_auth_tel = (rq, func)=>{
  auth_request({
    type: 'DELETE',
    url: '/tel/',
    data: rq,
    crud_name: '解除手机号绑定',
    success: func
  });
};

//
//     9、用户修改名称
// http://dms.gene.ac/dev/api/info/?api_no=202f5515889643dc90d592be0457036a
export const put_user_alias = (rq, func)=>{
  api_request({
    type: 'put',
    url: '/api/v2/biogpt/aftergo/user/',
    data: rq,
    crud_name: 'aftergo用户修改昵称',
    success: func
  });
};

//     10、获取用户信息（data.password_set=True/False）
// http://dms.gene.ac/dev/api/info/?api_no=ad08822e293311e6b38300163e002d04
//// api.js get_user
//     11、注册后授权
// http://dms.gene.ac/dev/api/info/?api_no=69b48254b15811e6b59800163e002d04
// api.js post_grant_genetic
//     备注： product、scope都传 “VIPaper”

// 12、token获取用户信息（验证）tel和alias
// http://dms.gene.ac/dev/api/info/?api_no=e2b4025001f011e69da800163e002d04
export const post_auth_token_confirm = (func)=>{
  auth_request({
    type: 'post',
    url: '/token/confirm/',
    data: {access_token: localStorage.getItem(xTokenKey)},
    crud_name: '验证access_token的有效性，获取tel和alias',
    success: func
  });
};

// 13、刷新token
// http://dms.gene.ac/dev/api/info/?api_no=c46cfa1620b011e6b41c00163e002d04
export const put_auth_token_refresh = (func)=>{
  auth_request({
    type: 'put',
    url: '/token/refresh/',
    data: {refresh_token: localStorage.getItem('refresh_token')},
    crud_name: '刷新token',
    success: func
  });
};